import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { OLAF, CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FREE } from 'self-service-api/constants/PurchaseTypes';
import FeatureModalSplitter from '../feature-modal/FeatureModalFS/FeatureModalSplitter';
const SelectorButton = styled.button.withConfig({
  displayName: "MobileProductLineSelectorButton__SelectorButton",
  componentId: "sc-1fwvllq-0"
})(["min-width:100%;font-size:0.75rem;padding:calc(1rem + 1px) 2rem;background:", ";flex-grow:1;flex-basis:33%;border:1px solid ", ";transition:background-color 0.3s;"], OLAF, CALYPSO_MEDIUM);

const MobileProductLineSelectorButton = ({
  productLine,
  handleShowModal,
  handleHideModal,
  active
}) => {
  const showFeaturesTable = evt => {
    evt.preventDefault();
    handleShowModal(productLine);
  };

  const hideFeaturesTable = evt => {
    evt.preventDefault();
    handleHideModal(productLine);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SelectorButton, {
      onClick: showFeaturesTable,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `productLine.${productLine}`
      })
    }), active && /*#__PURE__*/_jsx(FeatureModalSplitter, {
      onCloseClick: hideFeaturesTable,
      productLine: productLine,
      defaultProductLevel: FREE
    })]
  });
};

export default MobileProductLineSelectorButton;